import { MAX_PRICE_PAISE, parseRupees } from "@luckymenu/core";

/**
 * What is wrong with one field of a menu form. Both apps translate
 * `menu:fieldProblems.<problem>`. Keys are field names; list rows use
 * `variants.0.price`, `options.2.name`.
 */
export type FieldProblem =
	| "required"
	| "tooLong"
	| "price"
	| "priceTooHigh"
	| "shortCode"
	| "taken"
	| "diet"
	| "timeRange"
	| "minMax"
	| "maxOptions"
	| "tooMany"
	| "invalid";

export type FormErrors = Record<string, FieldProblem>;

/** Rupees as typed ("120", "12.50") to paise, or the problem. Empty is `required`. */
export function rupeesToPaise(text: string): { paise: number } | { problem: FieldProblem } {
	if (text.trim() === "") return { problem: "required" };
	const paise = parseRupees(text);
	if (paise === null) return { problem: "price" };
	if (paise > MAX_PRICE_PAISE) return { problem: "priceTooHigh" };
	return { paise };
}

/** Paise to the rupees a price field shows: 24000 → "240", 1250 → "12.50". */
export function paiseToRupees(paise: number): string {
	const rupees = Math.trunc(paise / 100);
	const rest = paise % 100;
	return rest === 0 ? String(rupees) : `${rupees}.${String(rest).padStart(2, "0")}`;
}

/** Field problems from a zod error on the API input, for anything the form did not catch. */
export function zodProblems(error: {
	issues: readonly { path: readonly PropertyKey[]; code: string }[];
}): FormErrors {
	const errors: FormErrors = {};
	for (const issue of error.issues) {
		const key = issue.path.map(String).join(".");
		if (key in errors) continue;
		errors[key] =
			issue.code === "too_big" ? "tooLong" : issue.code === "too_small" ? "required" : "invalid";
	}
	return errors;
}
